import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';
import { userApi } from './user';

type ValidateInviteResponse = {
  // Backend returns: { message: "Invitation valid." } on success
  message?: string;
  tenant_name?: string;
  tenant_id?: string;
  invitee_email?: string;
};

type SendInviteResponse = {
  message?: string; // e.g., "Inviting User"
  status?: string;
  email?: string;
};

export const inviteApi = createApi({
  reducerPath: 'inviteApi',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    // GET /api/v1/tenant/validate-invitation/{invitationHash}
    validateInvite: builder.query<ValidateInviteResponse, { invitationHash: string }>({
      query: ({ invitationHash }) => ({
        url: `/tenant/validate-invitation/${encodeURIComponent(invitationHash)}`,
        method: 'GET',
      }),
    }),
    // POST /api/v1/user/invite/
    sendInvite: builder.mutation<
      SendInviteResponse,
      { email: string; role?: string }
    >({
      query: (body) => ({
        url: `/user/invite/`,
        method: 'POST',
        body,
      }),
      // inviteApi and userApi are separate createApi slices, so a shared tag
      // won't cross between them — refresh the member list explicitly.
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(userApi.util.invalidateTags(['User']));
        } catch {
          // InviteSendModal surfaces the failure; nothing to refresh.
        }
      },
    }),
  }),
});

export const { useLazyValidateInviteQuery, useSendInviteMutation } = inviteApi;

export default inviteApi;

